export default __webpack_public_path__ + "static/media/samsung.091285f8.svg";